// Generated by scripts/update-seeq-icons.js from src/svg/seeq/treemap.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcTreemap = {
  prefix: 'fak',
  iconName: 'treemap' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e922',
    'M972.8 97.3h-921.6c-25.6 0-51.2 20.5-51.2 51.2v727c0 25.6 20.5 51.2 51.2 51.2h926.7c25.6 0 51.2-20.5 51.2-51.2v-727c-5.1-25.6-25.6-51.2-56.3-51.2zM926.7 496.6h-199.7v-296.9h199.7v296.9zM532.5 721.9h168.9v107.5h-168.9v-107.5zM532.5 660.5v-107.5h394.2v107.5h-394.2zM670.7 194.6v296.9h-573.4v-296.9h573.4zM97.3 553h373.7v276.4h-373.7v-276.4zM757.8 829.4v-107.5h168.9v107.5h-168.9z',
  ],
} satisfies IconDefinition;
